import { CompanyConnectedModel } from '../../models/company-connected.model'
import { CompanyConnectedDto } from '../dto/company-connected.dto'

const companyConnectedDtoToModelTransformer = (values: CompanyConnectedDto): CompanyConnectedModel[] => {
  return values['firma.ID'].map((_, index) => ({
    companyId: values?.['firma.ID']?.[index] ?? 0,
    companyName: values?.['firma.Name']?.[index] ?? null,
    companyAddressId: values?.['firma.Anschrift_ID']?.[index] ?? 0,
    companyManager: values?.['firma.Manager']?.[index] ?? null,
    companySapCustomerID: values?.['firma.sapCustomerID']?.[index] ?? null,
    companyShowroom: values?.['firma.showroom']?.[index] ?? null,
    companyZeroDeactivated: values?.['firma.ZERO_deactivated']?.[index] ?? null,
    companyUstId: values?.['firma.Ust_ID']?.[index] ?? null,
    companyShopPermission: values?.['firma.shopPermission']?.[index] ?? false,
    companyCreatedAt: values?.['firma.createdAt']?.[index] ?? '',
    companyUpdatedAt: values?.['firma.updatedAt']?.[index] ?? '',
    companyNdaSubmit: values?.['firma.NDA_submit']?.[index] ?? null,
    locationPhone: values?.['location.Telefon']?.[index] ?? null,
    locationAddress: values?.['location.Address']?.[index] ?? null,
    locationPlaceOr: values?.['location.PlaceOR']?.[index] ?? null,
    locationPlz: values?.['location.PLZ']?.[index] ?? null,
    locationCountry: values?.['location.Land']?.[index] ?? null,
    locationEmail: values?.['location.Email']?.[index] ?? null,
    managerName: values?.['manager.Name']?.[index] ?? null,
    managerFirstName: values?.['manager.Vorname']?.[index] ?? null,
    managerEmail: values?.['manager.Email']?.[index] ?? null,
  }))
}

export default companyConnectedDtoToModelTransformer
